// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum AlertChannel {
	None = 0,
	Email = 1,
	InApp = 2,
	Webhook = 4,
}

export const AlertChannelDisplayNames: { [key in keyof typeof AlertChannel]?: string} = {
	"None": "None",
	0 : "None",
	"Email": "Email",
	1 : "Email",
	"InApp": "InApp",
	2 : "InApp",
	"Webhook": "Webhook",
	4 : "Webhook",
}

export const getAlertChannelDisplayName = (key: AlertChannel | number |  (keyof typeof AlertChannel & string)) => {
	if (isNaN(+key)) return AlertChannelDisplayNames[key];
	return Object.keys(AlertChannelDisplayNames).filter(v => parseInt(v) >= 0 && (parseInt(v) & Number(key)) > 0).map(v => AlertChannelDisplayNames[v as (keyof typeof AlertChannel)]).join(', ');
}

